import * as React from 'react';

import { ClickAwayListener, Grid, Typography, makeStyles } from '@material-ui/core';

import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import AddHomeOutlinedIcon from '@mui/icons-material/AddHomeOutlined';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import NewReleasesOutlinedIcon from '@mui/icons-material/NewReleasesOutlined';
//
import CurrencyBitcoinOutlinedIcon from '@mui/icons-material/CurrencyBitcoinOutlined';
import EuroOutlinedIcon from '@mui/icons-material/EuroOutlined';
import Link from 'next/link';
import { setIs, setSelectedOrg } from '../../../../../redux/slices/clientRegistration';
import { useDispatch, useSelector } from 'react-redux';
import { me } from '../../../../../redux/slices/me';
import BeforeSendDialog from '../../old_OP/components/BeforeSendDialog';
import { requestOwner } from '../../../../../services/AgapeAPI';
import { toast } from 'react-toastify';

const useStyles = makeStyles(theme => ({
  container: {
    position: 'absolute',
    right: 0,
    width: '200px',
    maxWidth: '200px',
    minWidth: '100%',
    backgroundColor: '#fff',
    top: '50px',
    boxShadow: '0px 2px 4px 4px #0003',
    borderRadius: '5px',
    zIndex: 9999,
  },
  hr: {
    height: 1,
    backgroundColor: '#dadada',
  },
  items: {
    padding: 7,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#ddd',
    },
  },
  texts: {
    fontSize: 14,
    color: '#000',
  },

  iconSize: {
    fontSize: '24px',
    color: '#06a19d',
    margin: '0 5px',
    marginBottom: '-7px',
  },
  badge: {
    float: 'right',
    borderRadius: '100%',
    minWidth: 20,
    minHeight: 20,
    backgroundColor: '#00CECA',
    marginTop: 2,
    paddingTop: 2,
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'center',
  },
}));

const OptionsMenu = ({
  data,
  open,
  setOpen,
  openMembership,
  localFavorite,
  handleFavorite,
  currentCount,
  handleShareClicked,
  setOpenReport,
  ...props
}) => {
  const classes = useStyles();

  const user = useSelector(me);

  const dispatch = useDispatch();

  const close = () => {
    setOpen(!open);
  };

  const [openRequestOwner, setOpenRequestOwner] = React.useState(false);
  const [requestOwnerReadyToSend, setRequestOwnerReadyToSend] = React.useState(false);

  React.useEffect(() => {
    async function handleOwnershipRequest() {
      if (requestOwnerReadyToSend) {
        requestOwner(data?.code).then(response => {
          //  setHasRequestedOwner(true);
          localStorage.setItem(`reqOwner__${data?.code}`, true);
          toast.success('درخواست شما با موفقیت ثبت شد');
          close();
        });
      }
    }
    handleOwnershipRequest();
  }, [requestOwnerReadyToSend]);

  return (
    <>
      <BeforeSendDialog
        open={openRequestOwner}
        setOpen={setOpenRequestOwner}
        setReadyToSend={setRequestOwnerReadyToSend}
        title="آیا از ارسال درخواست اطمینان دارید؟"
        subtitle="تنها مدیر حقوقی سازمان می‌تواند با ثبت درخواست مدیریت از قابلیت‌های داشبورد اختصاصی بهره‌مند شود."
      />
      <ClickAwayListener onClickAway={close}>
        <Grid container className={classes.container}>
          {data.owner_id === null && (
            <>
              <Grid item xs={12} className={classes.items} onClick={() => setOpenRequestOwner(true)}>
                <Typography variant="h5" className={classes.texts}>
                  <ManageAccountsOutlinedIcon className={classes.iconSize} />
                  مدیر این موسسه هستید؟
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.hr} />
            </>
          )}

          <Grid item xs={12} className={classes.items}>
            <Link href={`/payment-methods/${data.code}/${data.slug}`}>
              <a>
                <Typography variant="h5" className={classes.texts}>
                  <PaymentsOutlinedIcon className={classes.iconSize} />
                  صفحه حمایت
                </Typography>
              </a>
            </Link>
          </Grid>
          <Grid item xs={12} className={classes.hr} />
          {(data.organization_category_id === 1 || data.organization_category_id === 2 || data.organization_category_id === 4) &&
          data.is_accepted_member === 1 ? (
            <>
              <Grid item xs={12} className={classes.items}>
                <Link href={`/membership/حقیقی/${data?.slug}/${data?.code}`}>
                  <Typography variant="h5" className={classes.texts}>
                    <AddHomeOutlinedIcon className={classes.iconSize} />
                    درخواست عضویت
                  </Typography>
                </Link>
              </Grid>
              <Grid item xs={12} className={classes.hr} />
            </>
          ) : null}

          {(data.organization_category_id === 2 || data.organization_category_id === 3) && data.accept_needful ? (
            <>
              <Grid item xs={12} className={classes.items}>
                <Link
                  href={`/client-registration/${data?.code}`}
                  onClick={() => {
                    dispatch(setSelectedOrg(data));
                    dispatch(setIs(true));
                  }}
                >
                  <a>
                    <Typography variant="h5" className={classes.texts}>
                      <GroupAddOutlinedIcon className={classes.iconSize} />
                      معرفی مددجو
                    </Typography>
                  </a>
                </Link>
              </Grid>
              <Grid item xs={12} className={classes.hr} />
            </>
          ) : null}
          <Grid item xs={12} className={classes.items} onClick={handleFavorite}>
            <Typography variant="h5" className={classes.texts}>
              {localFavorite ? <FavoriteIcon className={classes.iconSize} /> : <FavoriteBorderOutlinedIcon className={classes.iconSize} />}
              مورد علاقه
              <span className={classes.badge}>{currentCount}</span>
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.hr} />
          <Grid item xs={12} className={classes.items} onClick={handleShareClicked}>
            <Typography variant="h5" className={classes.texts}>
              <ShareOutlinedIcon className={classes.iconSize} />
              اشتراک گذاری
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.hr} />

          {user && user.id ? (
            <Grid item xs={12} className={classes.items} onClick={() => setOpenReport(true)}>
              <Typography variant="h5" className={classes.texts}>
                <NewReleasesOutlinedIcon className={classes.iconSize} />
                گزارش خطا
              </Typography>
            </Grid>
          ) : null}
        </Grid>
      </ClickAwayListener>
    </>
  );
};

export default OptionsMenu;
